const DEVICE_ID_KEY = "nihss.deviceId";
const SESSION_ID_KEY = "nihss.sessionId";
const DEFAULT_CLIENT_VERSION =
  process.env.REACT_APP_CLIENT_VERSION ||
  process.env.REACT_APP_GIT_SHA ||
  "web-0.1.1";

function createRandomId(prefix) {
  const randomPart =
    typeof window !== "undefined" &&
    window.crypto &&
    typeof window.crypto.randomUUID === "function"
      ? window.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  return `${prefix}-${randomPart}`;
}

function getStorageValue(storage, key, prefix) {
  if (!storage) {
    return createRandomId(prefix);
  }
  const existing = storage.getItem(key);
  if (existing) return existing;
  const created = createRandomId(prefix);
  storage.setItem(key, created);
  return created;
}

export function getBrowserDeviceId() {
  if (typeof window === "undefined") {
    return createRandomId("web-device");
  }
  return getStorageValue(window.localStorage, DEVICE_ID_KEY, "web-device");
}

export function getBrowserSessionId() {
  if (typeof window === "undefined") {
    return createRandomId("web-session");
  }
  return getStorageValue(window.sessionStorage, SESSION_ID_KEY, "web-session");
}

export function getBrowserSessionMetadata(sessionMode = "primary") {
  const sessionId = getBrowserSessionId();
  return {
    deviceId: getBrowserDeviceId(),
    sessionId,
    participantSessionId: sessionId,
    platform: "web",
    clientVersion: DEFAULT_CLIENT_VERSION,
    sessionMode: sessionMode || "primary",
  };
}
